module.exports = __webpack_public_path__ + "src/assets/img/illustrations/onboarding-intro-illustration.f45e71ded45dfb76b91a43f0b28edec9.png";